var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit1 = function SvgEdit1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".edit-1_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 11.5v11a1 1 0 0 1-1 1h-17a1 1 0 0 1-1-1v-19a1 1 0 0 1 1-1h13",
    className: "edit-1_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.824 14.007-4.949 2.12 2.121-4.95L20.674.5l2.828 2.828zM21.667 5.164l-2.829-2.829M12.824 14.007l-2.828-2.83",
    className: "edit-1_svg__a"
  })));
};
export default SvgEdit1;